/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type BindingRefreshAttempt = {
  attemptId: string;
};

/** @internal */
export const BindingRefreshAttempt$inboundSchema: z.ZodMiniType<
  BindingRefreshAttempt,
  unknown
> = z.pipe(
  z.object({
    attempt_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "attempt_id": "attemptId",
    });
  }),
);

export function bindingRefreshAttemptFromJSON(
  jsonString: string,
): SafeParseResult<BindingRefreshAttempt, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BindingRefreshAttempt$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BindingRefreshAttempt' from JSON`,
  );
}
